module.exports = __webpack_public_path__ + "static/img/MTI-EX-PRO-AB专业型.8e41c131.jpg";